'use client';

import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { handleOpenSpinToWinModal } from '@/redux/reducers/spin-the-wheel-reducer';
import { isSpinTheWheelEnded } from '@/utils/dateTime';

export default function SpinTheWheelInitializer() {
  const dispatch = useDispatch();
  const { isOpenSpinToWinModal, wheelList, fetchStatus, wheelDetails } =
    useSelector((state) => state.spinTheWheel);
  const { showSpinTheWheelPopup } = useSelector(
    (state) => state.globalSettings,
  );

  useEffect(() => {
    // Check if user previously closed the modal in this session
    const hasClosedModal = sessionStorage.getItem('spinModalClosed') || '';

    if (showSpinTheWheelPopup && !hasClosedModal) {
      // Only trigger if data is loaded and modal not already open
      if (
        fetchStatus === 'succeeded' &&
        wheelList?.length > 0 &&
        !isOpenSpinToWinModal
      ) {
        // Show modal if not closed before
        const isSpinCampaignActive = !isSpinTheWheelEnded({
          wheelDetails,
          list: wheelList,
        });
        // Only if spin campaign is active
        if (isSpinCampaignActive) {
          setTimeout(() => {
            dispatch(handleOpenSpinToWinModal());
            sessionStorage.setItem('spinModalClosed', 'true');
          }, 1000);
        }
      }
    }
  }, [fetchStatus, wheelList, isOpenSpinToWinModal, showSpinTheWheelPopup]);
  return null; // No UI, just behavior
}
